<template>
    <div :class="outerClass">
        <object v-if="type == 'svg'" :data="`/images/${VUE_APP_LOGO}${color}.${type}`" type="image/svg+xml" :class="innerClass"></object>
        <img v-else :src="`/images/${VUE_APP_LOGO}${color}.${type}`" :class="innerClass" :alt="altText" :style="innerStyle">
    </div>
    
</template>

<script>
export default {
    name: 'Logo',
    props: {
        type: {
            type: String,
            default: "svg"
        },
        color: {
            type: String,
            default: ""
        },
        outerClass: {
            type: String,
            default: ''
        },
        innerClass: {
            type: String,
            default: ''
        },
        altText: {
            type: String,
            default: 'Brand Logo'
        },
        innerStyle: {
            type: String,
            default: ''
        }
    },
    computed: {
        VUE_APP_LOGO(){
          return process.env.VUE_APP_LOGO
        }
    }
}
</script>

<style>

</style>
